const state = {
  openId: localStorage.getItem('openId')
}

const mutations = {
  SET_CLIENT_ID: (state, openId) => {
    state.openId = openId
    localStorage.setItem('openId', openId)
  }
}

const actions = {
  setOpenId({ commit, state }, openId) {
    commit('SET_CLIENT_ID', openId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
